<template>
  <div>
    <div v-if="task.kierowcy && task.kierowcy.length > 0">
      <span
        v-for="driver in task.kierowcy"
        :key="driver"
        class="d-block text-xs"
      >
        {{ driver.firstName }} {{ driver.surname }}
      </span>
    </div>
    <span
      v-show="!task.kierowcy || task.kierowcy.length === 0"
      class="text-xs"
    >
      Brak kierowców
    </span>
  </div>
</template>

<script>
export default {
  name: 'DriversOutput',
  props: ['task']
}
</script>

<style scoped>
.text-xs {
  font-size: .8rem;
}
</style>
